import { useEffect } from 'react'

export interface UseOutsideClickProps {
  ref: React.RefObject<HTMLElement>
  handler?: (e: Event) => void
  enabled?: boolean
}

export function useOutsideClick({
  ref,
  handler,
  enabled = true,
}: UseOutsideClickProps) {
  useEffect(() => {
    if (!enabled || !handler) return

    const listener = (event: MouseEvent | TouchEvent) => {
      const el = ref?.current
      if (!el || el.contains(event.target as Node)) {
        return
      }

      handler(event)
    }

    document.addEventListener('mousedown', listener)
    document.addEventListener('touchstart', listener)

    return () => {
      document.removeEventListener('mousedown', listener)
      document.removeEventListener('touchstart', listener)
    }
  }, [ref, handler, enabled])
}
